import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';

@Component({
	selector: 'app-invalid-form-drawer',
	standalone: false,
	templateUrl: './invalid-form-drawer.component.html',
	styleUrl: './invalid-form-drawer.component.scss'
})
export class InvalidFormDrawerComponent implements OnInit {
	@Input() form!: FormGroup;
	@Input() field?: string;
	@Input() fields?: string[];

	controls: { field: string; errors: string }[] = [];

	ngOnInit(): void {
		this.controls = this.getInvalidControlsList(this.form);
	}


	// getInvalidControlsList(group: FormGroup | FormArray = this.form, path: string = ''): { field: string; errors: string }[] {
	// 	let invalid: { field: string; errors: string }[] = [];

	// 	Object.keys(group.controls).forEach(key => {
	// 		const controlPath = path ? `${path}.${key}` : key;
	// 		const control = group.get(key)!;

	// 		if (control instanceof FormControl) {
	// 			if (control.invalid) {
	// 				const errorKeys = Object.keys(control.errors || {}).join(', ');
	// 				invalid.push({ field: controlPath, errors: errorKeys });
	// 			}
	// 		} else if (control instanceof FormGroup || control instanceof FormArray) {
	// 			invalid = invalid.concat(this.getInvalidControlsList(control, controlPath));
	// 		}
	// 	});
	// 	return invalid;
	// }



	private labelMap: Record<string, string> = {
		sections: 'Section',
		elements: 'Field',
		options: 'Option',
		orderIndex: 'Order',
		name: 'Name',
		label: 'Label',
		// add more mappings as needed
	};

	getInvalidControlsList(
		group: FormGroup | FormArray = this.form,
		path: string = ''
	): { field: string; errors: string }[] {
		let invalid: { field: string; errors: string }[] = [];

		Object.keys(group.controls).forEach(key => {
			const control = group.get(key)!;
			const controlPath = path ? `${path}.${key}` : key;

			if (control instanceof FormControl) {
				if (control.invalid) {
					const errorKeys = Object.keys(control.errors || {}).join(', ');
					if(((control as any) ['custom_indicator_comment'])){
						invalid.push({ field: this.makeFriendlyPath(((control as any) ['custom_indicator_comment'])), errors: errorKeys });
					}else{
						invalid.push({ field: this.makeFriendlyPath(controlPath), errors: errorKeys });
					}
				}
			} else if (control instanceof FormGroup || control instanceof FormArray) {
				if (control.invalid && control.errors) {
					const errorKeys = Object.keys(control.errors).join(', ');
					invalid.push({ field: this.makeFriendlyPath(controlPath), errors: errorKeys });
				}
				invalid = invalid.concat(this.getInvalidControlsList(control, controlPath));
			}
		});

		return invalid;
	}

	private makeFriendlyPath(path: string): string {
		return path
			.split('.')
			.map(p => {
				if (/^\d+$/.test(p)) {
					return `#${Number(p) + 1}`; // change "0" to "#1"
				}
				return this.labelMap[p] || p;
			})
			.join(' → '); // nice arrow separator
	}
}
